import { debounce, put, select, takeLatest } from 'redux-saga/effects';

import { DEBOUNCE_TIME } from 'constants/Global';
import { getImpersonateUsers } from 'modules/users/actions/impersonate';
import * as types from 'modules/users/actionTypes';

import { getImpersonateModalParameters } from './selectors';

function* onFiltersChangeWorker() {
  const params = yield select(getImpersonateModalParameters);
  yield put(getImpersonateUsers(params));
}

const filtersChannel = [
  types.OPEN_IMPERSONATE_MODAL,
  types.SET_IMPERSONATE_MODAL_FILTER,
  types.SET_IMPERSONATE_MODAL_FILTERS,
  types.CLEAR_IMPERSONATE_MODAL_FILTER,
  types.REMOVE_IMPERSONATE_MODAL_FILTER,
];

export default function* impersonateUserSagas() {
  yield debounce(DEBOUNCE_TIME, filtersChannel, onFiltersChangeWorker);
  yield takeLatest(types.OPEN_IMPERSONATE_MODAL, onFiltersChangeWorker);
}
